import React, { ImgHTMLAttributes } from 'react'

interface IProps extends ImgHTMLAttributes<any> {
  fallback: string
  handleFallback?: () => void
}

const ImageComponent: React.FC<IProps> = ({ fallback, src, ...props }) => {
  return <img src={src || fallback} onError={e => {
    e.currentTarget.src = fallback
    props.handleFallback && props.handleFallback()
  }}
  {...props} />
}
export default ImageComponent
